'use strict';

require('core-js/es6/math');

/* eslint no-proto: 0 */
var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  var nativeGetPrototypeOf = Object.getPrototypeOf;

  Object.getPrototypeOf = function (object) {
    if (object.__proto__) {
      return object.__proto__;
    }

    return nativeGetPrototypeOf.call(Object, object);
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/recharts/lib/polyfill.js
 ** module id = 1976
 ** module chunks = 3
 **/